/**
 * Meta/Facebook developer documentation URLs and constants
 * Centralized location for all Meta-related external links
 */

export const META_DOCUMENTATION_URLS = {
    WHATSAPP_TEMPLATE_CATEGORIZATION: 'https://developers.facebook.com/documentation/business-messaging/whatsapp/templates/template-categorization',
} as const;

